const toNumber = (i) => Number.parseInt(i, 10);
const isNumber = (i) => !Number.isNaN(i);

const filterByOnlyParsedNumbers = (items) =>
  items.map(toNumber).filter(isNumber);

export default filterByOnlyParsedNumbers;
